import React from "react";
import axios from "axios";
import { useState } from "react";
import ENDPOINT from '../../data/ENDPOINT';

const BugBountyForm = () => {
    const [formData, setFormData] = useState({
        bounty_title: "",
        organization_id: "",
        company_name: "",
        p1: "",
        p2: "",
        p3: "",
        p4: "",
        payout: "",
        category: "",
        link: "",
        image: "",
        start_date: "",
        deadline: "",
        status: "",
        tech_stack: "",
        bounty_description: "",
      });
    
      const [responseMessage, setResponseMessage] = useState("");
      const [loading, setLoading] = useState(false);
    
      const handleInputChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      };
    
      const handleAddBounty = async () => {
        const { bounty_title, organization_id, company_name, start_date, deadline, status, tech_stack, bounty_description } = formData;
    
        if (!bounty_title || !organization_id || !company_name || !start_date || !deadline || !status || !tech_stack || !bounty_description) {
          alert("Please fill all required fields.");
          return;
        }
    
        setLoading(true);
        setResponseMessage("");
    
        try {
          const response = await axios.post(
            `${ENDPOINT}add-bounty.php`,
            new URLSearchParams(formData)
          );
    
          const { status, message } = response.data;
    
          if (status === "success") {
            alert("Bounty added successfully!");
            setResponseMessage(message);
          } else {
            setResponseMessage(`Error: ${message}`);
          }
        } catch (error) {
          console.error("Error adding bounty:", error);
          setResponseMessage("An unexpected error occurred.");
        } finally {
          setLoading(false);
        }
      };

  return (
    <div className="container col-lg-7 mt-4">
      <h2 className="mb-3">Add New Bounty</h2>
      <form  className="p-4 border rounded shadow">
        <div className="mb-3">
          <label className="form-label">Bounty Title:</label>
          <input type="text" name="bounty_title" className="form-control" value={formData.bounty_title} onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Organization ID:</label>
          <input type="text" name="organization_id" className="form-control" value={formData.organization_id} onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Company Name:</label>
          <input type="text" name="company_name" className="form-control" value={formData.company_name} onChange={handleInputChange} required />
        </div>

        <div>
        <label>P1:</label>
        <input type="number" name="p1" value={formData.p1} onChange={handleInputChange} placeholder="Enter P1" />
      </div>
      <div>
        <label>P2:</label>
        <input type="number" name="p2" value={formData.p2} onChange={handleInputChange} placeholder="Enter P2" />
      </div>
      <div>
        <label>P3:</label>
        <input type="number" name="p3" value={formData.p3} onChange={handleInputChange} placeholder="Enter P3" />
      </div>
      <div>
        <label>P4:</label>
        <input type="number" name="p4" value={formData.p4} onChange={handleInputChange} placeholder="Enter P4" />
      </div>

        <div className="mb-3">
          <label className="form-label">Payout:</label>
          <input type="number" name="payout" className="form-control" value={formData.payout} onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Category:</label>
          <input type="text" name="category" className="form-control" value={formData.category} onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Link:</label>
          <input type="url" name="link" className="form-control" value={formData.link} onChange={handleInputChange} />
        </div>

        <div className="mb-3">
          <label className="form-label">Image URL:</label>
          <input type="url" name="image" className="form-control" value={formData.image} onChange={handleInputChange} />
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Start Date:</label>
            <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={handleInputChange} required />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Deadline:</label>
            <input type="datetime-local" name="deadline" className="form-control" value={formData.deadline} onChange={handleInputChange} required />
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Status:</label>
          <input type="text" name="status" className="form-control" value={formData.status} onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Tech Stack:</label>
          <input type="text" name="tech_stack" className="form-control" value={formData.tech_stack} onChange={handleInputChange} required />
        </div>

        <div className="mb-3">
          <label className="form-label">Bounty Description:</label>
          <textarea name="bounty_description" className="form-control" rows="3" value={formData.bounty_description} onChange={handleInputChange}></textarea>
        </div>

        <button className="btn btn-primary w-100" onClick={handleAddBounty} disabled={loading}>
        {loading ? "Adding..." : "Add Bounty"}
     </button>
     {responseMessage && <p>{responseMessage}</p>}
      </form>
    </div>
  );
};

export default BugBountyForm;
